<template>
  <div
    :class="$style.icon"
    class="mt-icon mt-icon-warning"
  />
</template>

<script type="text/ecmascript-6">
export default {
  name: 'WarningIcon'
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';
@import "mpl-css/lib/assets/global/icons/icons-colors";
$warning-fill: encodeHexColor(map-get($colors, 'white'));
@import "mpl-css/lib/assets/global/icons/icons-svg";
$warningIcon: map-get($icons, 'warning');
.icon {
  position: relative;
  width: rem(28);
  height: rem(28);
  border-radius: 50%;
  background-color: map-get($colors, 'orange');
  &:before {
    background-image: url($warningIcon);
    background-size: 60% 60%;
  }
}
</style>
